// extracted by mini-css-extract-plugin
module.exports = {"bevel":"masks-module--bevel--2VMxI","ellipse":"masks-module--ellipse--C_WAY"};